import { axiosClient } from "../../../config/axios";

export const getFoodListApi = async () => {
	const res = await axiosClient.get("/order/food/list");

	return res;
};
